import { render, staticRenderFns } from "./PurchaseChart.vue?vue&type=template&id=a403dfbc"
import script from "./PurchaseChart.vue?vue&type=script&lang=ts"
export * from "./PurchaseChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a403dfbc')) {
      api.createRecord('a403dfbc', component.options)
    } else {
      api.reload('a403dfbc', component.options)
    }
    module.hot.accept("./PurchaseChart.vue?vue&type=template&id=a403dfbc", function () {
      api.rerender('a403dfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/PurchaseChart.vue"
export default component.exports